"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalStyles = void 0;

var _styledComponents = require("styled-components");

var _getSpacing = require("../styleHelpers/getSpacing");

var _styleHelpers = require("../styleHelpers");

var modalStyles = {
  backdropColor: (0, _styleHelpers.getColor)('blackOpacity', '600'),
  padding: (0, _getSpacing.getSpacing)(7),
  gap: (0, _getSpacing.getSpacing)(5),
  backdropTransition: [['opacity', '0.3s']],
  box: {
    closedTransform: (0, _styledComponents.css)(["translateY(60px)"]),
    transition: [['transform', '0.3s']],
    shadow: ['0px 4px 20px rgba(0, 0, 0, 0.2)'],
    backgroundColor: (0, _styleHelpers.getBackgroundColor)(),
    padding: (0, _getSpacing.getSpacing)(5),
    maxWidth: {
      small: '520px',
      medium: '780px',
      large: '1000px',
      full: '100%'
    },
    borderRadius: 12
  }
};
exports.modalStyles = modalStyles;